import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Validate from '../common/formValidate';
import FormField from '../common/FormField';

class ForgotPasswordForm extends React.Component {
  render() {
    const { handleSubmit, inProgress } = this.props;
    const lower = value => value && value.toLowerCase();
    return (
      <form onSubmit={handleSubmit} className="forgot-password-form">
        <div className="login-form-input">
          <Field
            name="email"
            component={FormField}
            type="text"
            label="mail@example.com"
            description="Password reset link will be sent to your email."
            validate={[Validate.Required, Validate.Email]}
            normalize={lower}/>
        </div>
        <button
          className="col-md-8 btn btn-block btn-primary pull-right"
          disabled={inProgress}
          type="submit">Submit</button>
      </form>
    );
  }
}

export default ForgotPasswordForm = reduxForm({
  form: 'ForgotPasswordForm'
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/components/login/ForgotPasswordForm.js